<div class="app-outage-banner">
  <span class="banner-text centered-container">
    &#9888; {{ outageMessage }} &#9888;
  </span>
</div>
